// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"be66a967","455":"a29de7f9","977":"b1e93e0e"}[chunkId] + ".chunk.js";
};